// src/services/deliverablesApi.js
/* eslint-disable */
import { client } from "./axiosClient";

export const listDeliverables = (initiativeId) =>
  client.post("/api/initiative_deliverables/", {
    action: "list",
    initiative_id: initiativeId,
  });

export const createDeliverable = (payload) =>
  client.post("/api/initiative_deliverables/", {
    action: "create",
    ...payload,
  });

export const updateDeliverable = (payload) =>
  client.post("/api/initiative_deliverables/", {
    action: "update",
    ...payload,
  });

export const deleteDeliverable = (deliverable_id) =>
  client.post("/api/initiative_deliverables/", {
    action: "delete",
    deliverable_id,
  });

export const performApprovalAction = (
  payload // { deliverable_id, action, comment }
) => client.post("/api/deliverable-approval-action/", payload);

export const approveAllDeliverables = (initiativeId) =>
  client.post("/api/deliverables-approve-all/", {
    initiative_id: initiativeId,
  });
